<template>
  <!-- !!! -->
  <!-- !!! -->
  <!-- !!! -->
  <!-- 若有改动，请仔细观察后端返回格式再来修改 -->
  <div>
    <div style="background-color: #ffffff;width: 100%;height: 70vh">
      <date-select @StatisticType="GetStatisticType"></date-select>
      <v-chart :options="option" :autoresize="true" v-show="CharShow"/>
    </div>
  </div>
</template>

<script>
import ECharts from "vue-echarts";
import "echarts/lib/chart/line";
import "echarts/lib/component/polar";
import "echarts/lib/component/dataZoom";
import DateSelect from "./components/DateSelect";
import { listRssi,mocklistRssi } from "@/api/signalstatistics";
import { tooltipFormate,
         axisFormate,
         otherStyle, 
         GetsignalstatisticsYear,
         GetsignalstatisticsDay,
         GetsignalstatisticsTime,
         GetsignalstatisticsMinute 
} from './components/GetValue'
import { mapGetters } from 'vuex'
export default {
  name: 'Signalstatistics',
  data() {
    return {
      CharShow:false,
      option: {}
    };
  },
  components: {
    DateSelect
  },
  mounted() {
    //进入页面获取信号统计
    listRssi({year: new Date().getFullYear(),gid:this.defaultGroupId}).then((res)=>{
      for(let key in res.data.data){
        console.log(typeof key)
        const Data=GetsignalstatisticsYear(new Date().getFullYear(),res.data.data,key.slice(3))
        //如果筛选出来的数据没有时间隐藏图表
        Data.Time.length>0?this.CharShow=true:this.CharShow=false
        this.setOptions(1, Data.Time, Data.data)
      }
    })
  },
  methods: {
    // 设置图形样式和数据，不同统计类型有不同的样式
    setOptions(statistisType, xAxisData, seriesData) {
      this.option = {
        backgroundColor: "#fff",
        color: ["#37A2DA", "#32C5E9"],
        tooltip: {
          trigger: "axis",
          axisPointer: otherStyle.axisPointer,
          // 鼠标悬浮时显示数据的样式
          formatter: function (params) {
            let name = tooltipFormate(params, statistisType)
            return `${name}<br />
                    <span style="width: 10px;height: 10px;background-color: #37A2DA;border-radius: 50%;vertical-align: middle;display: inline-block;"></span>
                    ${params[0].seriesName} : ${params[0].value}<br />
                    <span style="width: 10px;height: 10px;background-color: #32C5E9;border-radius: 50%;vertical-align: middle;display: inline-block;"></span>
                    ${params[1].seriesName} : ${params[1].value}`
          },
        },
        // 下方滑动条
        dataZoom: otherStyle.dataZoom,
        legend: {
          data: [
            {
              name: `3GWAN1${this.$t('lang.ReportManagement.signals')}`,
              icon: "circle",
              textStyle: {
                color: "#7d838b"
              }
            },
            {
              name: `3GWAN2${this.$t('lang.ReportManagement.signals')}`,
              icon: "circle",
              textStyle: {
                color: "#7d838b"
              }
            }
          ],
          top: "10%",
          textStyle: {
            color: "#fff"
          }
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: xAxisData,
          axisLabel: {
            interval: 0,
            formatter: function (value, index) {
              let val = axisFormate(value, statistisType)
                return val         
              },
          },
          // 刻度样式
          axisTick:{     
            inside: true, // 设置刻度朝内
          },
        },
        yAxis: {
          type: "value",
          name: `${this.$t('lang.ReportManagement.Units')}`
        },
        grid: otherStyle.grid,
        series: [
          {
            name: `3GWAN1${this.$t('lang.ReportManagement.signals')}`,
            type: "line",
            symbol: "none",
            data: seriesData.net3gwan1
          },
          {
            name: `3GWAN2${this.$t('lang.ReportManagement.signals')}`,
            type: "line",
            symbol: "none",
            data: seriesData.net3gwan2
          }
        ]
      }
    },
    //统计查询事件触发
    GetStatisticType(data,DayClass) {
      console.log(data)
        //获取统计的类型
        let Value=data.DateClassValue
        //删除统计类型
        delete data.DateClassValue
        //获取筛选后的数据与时间
        let Data;
        //请求数据
      listRssi(data).then(res => {
        switch (Value) {
          case 4:
            Data=GetsignalstatisticsMinute(data.clock,res.data.data,data.dids[0])
            //如果筛选出来的数据没有时间隐藏图表
            Data.Time.length>0?this.CharShow=true:this.CharShow=false
             this.setOptions(4, Data.Time, Data.data)
            break;
          case 3:
            Data=GetsignalstatisticsTime(res.data.data,data.dids[0])
            //如果筛选出来的数据没有时间隐藏图表
            Data.Time.length>0?this.CharShow=true:this.CharShow=false
            this.setOptions(3, Data.Time, Data.data)
            break;
          case 2:
            Data=GetsignalstatisticsDay(data.month,DayClass,res.data.data,data.dids[0])
            //如果筛选出来的数据没有时间隐藏图表
            Data.Time.length>0?this.CharShow=true:this.CharShow=false
             this.setOptions(2, Data.Time, Data.data)
            break;
          case 1:
            Data=GetsignalstatisticsYear(data.year,res.data.data,data.dids[0])
            //如果筛选出来的数据没有时间隐藏图表
            Data.Time.length>0?this.CharShow=true:this.CharShow=false
            this.setOptions(1, Data.Time, Data.data)
            break;
        }
        if(Object.keys(Data.data.net3gwan1).length<1&&Object.keys(Data.data.net3gwan2).length<1){
          this.$confirm(this.$t('lang.ReportManagement.datatype'), this.$t('lang.ReportManagement.setPrompt'), {
          confirmButtonText: this.$t('lang.ReportManagement.Determine'),
          showCancelButton:false,
          type: 'warning',
          center: true
        })
      }
      });
    }
  },
  computed:{
    ...mapGetters(['defaultGroupId'])
  }
};
</script>

<style scoped>
.inputlist {
  width: 1.8rem;
  margin: 0.1rem;
}
.echarts {
  width: 100%;
  height: 90%;
}
</style>
